import ArrayUtils from '../utils/ArrayUtils'
import i18n from '../i18n'

const PageKindType = Object.freeze({
  Vacation: 1,
  Mission: 2,
  IO: 3,
  ExtraWork: 4,
  SpecificExtraWork: 5,
});

const PageKindEnum = Object.freeze({
  1: i18n.t('vacation'),
  2: i18n.t('MISSION'),
  3: i18n.t('io'),
  4: i18n.t('EXTRAWORK'),
  5: i18n.t('specificExtraWork'),
})

const RequestTypeArray = function () {
  return ArrayUtils.EnumToArray(PageKindEnum)
}
export default { PageKindType, PageKindEnum, RequestTypeArray };